import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { MapUserLayerExportType } from '@navfleet/client/map/user-layer/domain/models';
import {
    UserDataLayer,
    UserDataLayerObject,
    UserDataLayerObjectResponse,
    UserDataLayerResponse,
} from '@navfleet/client/map/user-data-layer/domain/models';
import { environment } from '@navfleet/shared/core/environment';

const USER_DATA_LAYERS_URL = `${environment.NAVFLEET_BACKEND}/api/v1/users/data-layers`;

@Injectable({
    providedIn: 'root',
})
export class UserDataLayerApi {
    private http = inject(HttpClient);

    public getAllUserDataLayers() {
        return this.http.get<UserDataLayerResponse[]>(USER_DATA_LAYERS_URL);
    }

    public getUserDataLayer(layerId: number) {
        return this.http.get<UserDataLayerResponse>(`${USER_DATA_LAYERS_URL}/${layerId}`);
    }

    public addUserDataLayer(userDataLayer: UserDataLayer) {
        return this.http.post<UserDataLayerResponse>(USER_DATA_LAYERS_URL, userDataLayer);
    }

    public updateUserDataLayer(userDataLayer: UserDataLayer) {
        return this.http.put<UserDataLayerResponse>(`${USER_DATA_LAYERS_URL}/${userDataLayer.id}`, userDataLayer);
    }

    public deleteUserLayer(layerId: number) {
        return this.http.delete(`${USER_DATA_LAYERS_URL}/${layerId}`);
    }

    public addUserDataLayerObject(object: UserDataLayerObject) {
        return this.http.post<UserDataLayerObjectResponse>(`${USER_DATA_LAYERS_URL}/${object.layerId}/objects`, object);
    }

    public updateUserDataLayerObject(object: UserDataLayerObject) {
        return this.http.put<UserDataLayerObjectResponse>(
            `${USER_DATA_LAYERS_URL}/${object.layerId}/objects/${object.objectId}`,
            object
        );
    }

    public deleteUserDataLayerObject(object: UserDataLayerObject) {
        return this.http.delete(`${USER_DATA_LAYERS_URL}/${object.layerId}/objects/${object.objectId}`);
    }

    public getAttachment(attachmentId: string) {
        return this.http.get(`${USER_DATA_LAYERS_URL}/objects/attachments/${attachmentId}`, {
            responseType: 'blob',
        });
    }

    public convertFile(file: File) {
        const formData = new FormData();
        formData.append('file', file, file.name);

        return this.http.post<UserDataLayerResponse[]>(`${USER_DATA_LAYERS_URL}/import`, formData);
    }

    public exportUserDataLayerObjects(layerId: string, objectsIds: number[], exportType: MapUserLayerExportType) {
        return this.http.post(`${USER_DATA_LAYERS_URL}/${layerId}/export/${exportType}`, objectsIds, {
            responseType: 'blob',
        });
    }
}
